// extracted by mini-css-extract-plugin
module.exports = {"text_wrapper":"no-survey_text_wrapper__J0Q-_"};